import { render, staticRenderFns } from "./CardDashboardStepTrackerSkeleton.vue?vue&type=template&id=2f12c82a&scoped=true"
import script from "./CardDashboardStepTrackerSkeleton.vue?vue&type=script&lang=js"
export * from "./CardDashboardStepTrackerSkeleton.vue?vue&type=script&lang=js"
import style0 from "./CardDashboardStepTrackerSkeleton.vue?vue&type=style&index=0&id=2f12c82a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f12c82a",
  null
  
)

export default component.exports